<template>
  <div @dragover="onDragOverFiles" @dragleave="onDragLeaveFiles">
    <div v-if="errors.length">
      <d-alert
        class="mb-0"
        v-for="error in errors"
        :key="error"
        theme="danger"
        show
        dismissible
        >{{ error }}</d-alert
      >
    </div>
    <div
      class="btn-wrapper d-flex justify-content-md-end justify-content-center"
    >
      <button
        class="btn btn-outline-primary wizard-btn prev-btn"
        @click="previous"
      >
        <i class="fa fa-arrow-left" aria-hidden="true"></i>
        {{ $t("global.return") }}
      </button>
      <button
        class="btn btn-primary wizard-btn next-btn"
        @click="nextStep"
        :disabled="false"
      >
        {{ $t("global.next") }}
        <i class="fa fa-arrow-right" aria-hidden="true"></i>
      </button>
    </div>
    <div class="row mb-4 mt-3">
      <div class="col-md-6 mb-3">
        <div class="card custom-card">
          <div class="card-body">
            <div class="py-2 px-3 custom-card">
              <h5>Renseignements du vacataire</h5>
              <div class="row">
                <div class="col-12 col-lg-6 jjj px-4">
                  <label for="male"
                    >Titre <span class="text-red">*</span></label
                  >
                  <div class="d-flex mr-5 mt-1">
                    <div class="custom-control custom-radio mb-1 ml-3 mr-5">
                      <input
                        type="radio"
                        id="male"
                        :value="true"
                        name="male"
                        v-model="isMale"
                        class="custom-control-input"
                      />
                      <label class="custom-control-label" for="male"
                        >Monsieur</label
                      >
                    </div>
                    <div class="custom-control custom-radio mb-1 ml-3">
                      <input
                        type="radio"
                        id="female"
                        :value="false"
                        name="female"
                        v-model="isMale"
                        class="custom-control-input"
                      />
                      <label class="custom-control-label" for="female"
                        >Madame</label
                      >
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6 jjj px-4">
                  <label for="lastName"
                    >Nom <span class="text-red">*</span></label
                  >
                  <d-input
                    type="text"
                    id="lastName"
                    v-model="lastName"
                    :state="errors['lastName'] === undefined ? null : false"
                  />
                  <errors :errors="errors" field="lastName" />
                </div>
                <div class="col-12 col-lg-6 jjj px-4">
                  <label for="firstName"
                    >Prénom <span class="text-red">*</span></label
                  >
                  <d-input
                    type="text"
                    id="firstName"
                    v-model="firstName"
                    :state="errors['firstName'] === undefined ? null : false"
                  />
                  <errors :errors="errors" field="firstName" />
                </div>
                <div class="col-12 col-lg-6 jjj px-4">
                  <label for="dateOfBirth"
                    >Date de naissance <span class="text-red">*</span></label
                  >
                  <d-datepicker
                    id="dateOfBirth"
                    class="pr-1"
                    v-model="dateOfBirth"
                    placeholder="Date de debut"
                    @input="checkDates"
                    :input-class="['form-control']"
                    :language="fr"
                    small
                  ></d-datepicker>
                </div>
                <div class="col-12 col-lg-6 jjj px-4">
                  <label for="birthPlace"
                    >Lieu de naissance <span class="text-red">*</span></label
                  >
                  <d-input
                    type="text"
                    id="birthPlace"
                    v-model="birthPlace"
                    :state="errors['birthPlace'] === undefined ? null : false"
                  />
                  <errors :errors="errors" field="birthPlace" />
                </div>
                <div class="col-12 col-lg-6 jjj px-4">
                  <label for="nationality"
                    >Nationalité <span class="text-red">*</span></label
                  >
                  <d-input
                    type="text"
                    id="nationality"
                    v-model="nationality"
                    :state="errors['nationality'] === undefined ? null : false"
                  />
                  <errors :errors="errors" field="nationality" />
                </div>
                <div class="col-12 col-lg-6 jjj px-4">
                  <label for="phoneNumber"
                    >Tél. <span class="text-red">*</span></label
                  >
                  <d-input
                    type="text"
                    id="phoneNumber"
                    v-model="phoneNumber"
                    :state="errors['phoneNumber'] === undefined ? null : false"
                  />
                  <errors :errors="errors" field="phoneNumber" />
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-lg-6 jjj px-4">
                  <label for="socialSecurityNumber"
                    >Numéro de sécurité sociale
                    <span class="text-red">*</span></label
                  >
                  <d-input
                    type="text"
                    id="socialSecurityNumber"
                    v-model="socialSecurityNumber"
                    :state="
                      errors['socialSecurityNumber'] === undefined
                        ? null
                        : false
                    "
                  />
                  <errors :errors="errors" field="socialSecurityNumber" />
                </div>
                <div class="col-12 col-lg-6 jjj px-4">
                  <label for="poleEmploiInscriptionNumber"
                    >Numéro inscription Pôle Emploi</label
                  >
                  <d-input
                    type="text"
                    id="poleEmploiInscriptionNumber"
                    v-model="poleEmploiInscriptionNumber"
                    :state="
                      errors['poleEmploiInscriptionNumber'] === undefined
                        ? null
                        : false
                    "
                  />
                  <errors
                    :errors="errors"
                    field="poleEmploiInscriptionNumber"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-lg-12 jjj px-4">
                  <label for="email"
                    >Adresse mail <span class="text-red">*</span></label
                  >
                  <span @focusout="checkEmail" @change="checkEmail">
                    <d-input
                      v-bind:class="{ emailExist: emailAlreadyExist }"
                      type="email"
                      id="email"
                      v-model="email"
                      :state="errors['email'] === undefined ? null : false"
                    />
                  </span>
                  <errors :errors="errors" field="email" />
                  <span
                    v-if="emailAlreadyExist"
                    class="emailExistErrorText mt-2"
                    >ce email existe déjà
                  </span>
                  <span
                    v-if="emailAlreadyExist"
                    class="emailExistErrorText emailExistErrorTextUnder mt-2"
                    @click="goToEmployeeExist"
                  >
                    aller à l'employé</span
                  >
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-lg-12 jjj px-4">
                  <label for="adresse"
                    >Adresse <span class="text-red">*</span></label
                  >
                  <d-input
                    type="text"
                    id="adresse"
                    v-model="adresse"
                    :state="errors['adresse'] === undefined ? null : false"
                  />
                  <errors :errors="errors" field="adresse" />
                </div>
                <div class="col-12 col-lg-6 jjj px-4">
                  <label for="postalCode"
                    >Code postal <span class="text-red">*</span></label
                  >
                  <d-input
                    type="text"
                    id="postalCode"
                    v-model="postalCode"
                    :state="errors['postalCode'] === undefined ? null : false"
                  />
                  <errors :errors="errors" field="postalCode" />
                </div>
                <div class="col-12 col-lg-6 jjj px-4">
                  <label for="city"
                    >Ville <span class="text-red">*</span></label
                  >
                  <d-input
                    type="text"
                    id="city"
                    v-model="city"
                    :state="errors['city'] === undefined ? null : false"
                  />
                  <errors :errors="errors" field="city" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card custom-card mt-5">
          <div class="card-body">
            <div class="py-2 px-3 custom-card">
              <h5>Documents obligatoires</h5>
              <div class="d-flex">
                <div class="col-6 px-1">
                  <file-upload :document="ID" />
                </div>
                <div class="col-6 px-1">
                  <file-upload :document="CV" />
                </div>
              </div>
              <h5>Autres documents</h5>
              <div class="d-flex flex-wrap">
                <div class="col-6 px-1" v-for="doc in otherDocumentsPaths">
                  <file-upload :document="doc" />
                </div>
                <div class="col-6 px-1">
                  <button class="document-add-button" @click="addOtherDocument">
                    <i class="fa fa-plus" aria-hidden="true"></i>
                    Ajouter un document
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div v-if="!isCEE" class="card custom-card mb-5">
          <div class="card-body">
            <div class="py-2 px-3 custom-card">
              <h5>Type de contrat <span class="text-red">*</span></h5>
              <div class="row">
                <div class="col-12 col-lg-6 jjj px-4">
                  <fieldset class="mt-0">
                    <d-form-radio
                      v-model="type"
                      :value="contractType.LEARN.value"
                      checked
                      class="mb-3"
                      >{{ contractType.LEARN.name }}</d-form-radio
                    >
                    <d-form-radio
                      v-model="type"
                      :value="contractType.UNPAID.value"
                      class="mb-3"
                      >{{ contractType.UNPAID.name }}</d-form-radio
                    >
                    <d-form-radio
                      v-model="type"
                      :value="contractType.OTHER.value"
                      class="mb-3"
                      >{{ contractType.OTHER.name }}</d-form-radio
                    >
                  </fieldset>
                </div>
                <div class="col-12 col-lg-6 jjj px-4">
                  <fieldset class="mt-0">
                    <d-form-radio
                      v-model="type"
                      :value="contractType.CDD.value"
                      class="mb-3"
                      >{{ contractType.CDD.name }}</d-form-radio
                    >
                    <d-form-radio
                      v-model="type"
                      :value="contractType.CDI.value"
                      class="mb-3"
                      >{{ contractType.CDI.name }}</d-form-radio
                    >
                  </fieldset>
                </div>
                <div v-if="type === contractType.OTHER.value" class="col-12">
                  <textarea
                    class="form-control mt-4"
                    v-model="otherContract"
                    cols="30"
                    rows="7"
                    :placeholder="
                      $t('days.off.request.step.four.explainPlaceHolder')
                    "
                  ></textarea>
                  <errors field="otherContract" :errors="errors"></errors>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card custom-card">
          <div class="card-body">
            <div class="py-2 px-3 custom-card">
              <h5>Structure <span class="text-red">*</span></h5>
              <fieldset class="mt-0 d-flex flex-wrap">
                <div
                  v-for="structure in allStructures"
                  class="col-6 div-no-padding"
                >
                  <d-form-radio
                    v-model="selectedStructure"
                    :value="{ name: structure.name, id: structure.reference }"
                    class="mb-3"
                    >{{ structure.name }}</d-form-radio
                  >
                </div>
              </fieldset>
            </div>
          </div>
        </div>
        <div v-if="isCEE" class="card custom-card mt-5">
          <div class="card-body">
            <div class="py-2 px-3 custom-card">
              <h5>Type de CEE <span class="text-red">*</span></h5>
              <fieldset class="mt-0 d-flex flex-row">
                <div class="col-6 div-no-padding">
                  <d-form-radio
                    v-model="CEEType"
                    value="Séjour de vacances"
                    class="mb-3"
                    >Séjour de vacances</d-form-radio
                  >
                </div>
                <div class="col-6 div-no-padding">
                  <d-form-radio v-model="CEEType" value="ACM" class="mb-3"
                    >ACM</d-form-radio
                  >
                </div>
              </fieldset>
            </div>
          </div>
        </div>
        <div class="card custom-card mt-5">
          <div class="card-body">
            <div class="py-2 px-3 custom-card">
              <h5>Détails du contrat <span class="text-red">*</span></h5>
              <div class="row">
                <div v-if="!isCEE" class="col-12 col-lg-12 jjj px-4">
                  <label for="fonction"
                    >Fonction <span class="text-red">*</span></label
                  >
                  <d-input
                    type="text"
                    id="fonction"
                    v-model="fonction"
                    placeholder="Chargé de"
                    :state="errors['fonction'] === undefined ? null : false"
                  />
                  <errors :errors="errors" field="fonction" />
                </div>
                <div class="col-12 col-lg-6 jjj px-4">
                  <label for="dateDeFin"
                    >Est ce que le contrat a une date de fin ?
                  </label>
                  <div class="d-inline-flex mr-5">
                    <div class="custom-control custom-radio mb-3 ml-3 mr-5">
                      <input
                        type="radio"
                        id="yes-end-day"
                        :value="true"
                        name="yes-end-day"
                        v-model="isThereEndDate"
                        class="custom-control-input"
                      />
                      <label class="custom-control-label" for="yes-end-day"
                        >Oui</label
                      >
                    </div>
                    <div class="custom-control custom-radio mb-3 ml-3">
                      <input
                        type="radio"
                        id="no-end-day"
                        :value="false"
                        name="no-end-day"
                        v-model="isThereEndDate"
                        class="custom-control-input"
                      />
                      <label class="custom-control-label" for="no-end-day"
                        >Non</label
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-lg-6 jjj px-4">
                  <label for="dateFrom"
                    >Date de début <span class="text-red">*</span></label
                  >
                  <d-datepicker
                    id="dateFrom"
                    class="pr-1"
                    v-model="dateFrom"
                    placeholder="Date de debut"
                    @input="checkDates"
                    :input-class="['form-control']"
                    :language="fr"
                    small
                  ></d-datepicker>
                </div>
                <div v-if="isThereEndDate" class="col-12 col-lg-6 jjj px-4">
                  <label for="dateTo"
                    >Date de fin <span class="text-red">*</span></label
                  >
                  <d-datepicker
                    id="dateTo"
                    class="pr-1"
                    v-model="dateTo"
                    placeholder="Date de fin"
                    @input="checkDates"
                    :input-class="['form-control']"
                    :language="fr"
                    small
                  ></d-datepicker>
                </div>
                <div class="col-12 col-lg-6 jjj px-4">
                  <label v-if="isCEE" for="daysOfContract"
                    >Nombre de jours CEE pour ce contrat</label
                  >
                  <label v-else for="daysOfContract"
                    >Nombre de jours du contrat
                    <span class="text-red">*</span></label
                  >
                  <d-input
                    type="text"
                    id="daysOfContract"
                    v-model="daysOfContract"
                    :state="
                      errors['daysOfContract'] === undefined ? null : false
                    "
                  />
                  <errors :errors="errors" field="daysOfContract" />
                </div>
                <div v-if="isCEE" class="col-12 col-lg-12 jjj px-4">
                  <label for="daysOfContractPast11Months"
                    >Nombre de jour(s) travaillé(s) en qualité d'engagé éducatif
                    sur les 11 derniers mois</label
                  >
                  <d-input
                    type="text"
                    id="daysOfContractPast11Months"
                    v-model="daysOfContractPast11Months"
                    :state="
                      errors['daysOfContractPast11Months'] === undefined
                        ? null
                        : false
                    "
                  />
                  <errors :errors="errors" field="daysOfContractPast11Months" />
                </div>
              </div>
            </div>
          </div>
          <div class="bg-purple">
            <div class="mb-4 mt-3">
              <div class="card-body">
                <div class="py-2 px-3 d-flex justify-content-between">
                  <h5 class="mt-0 d-inline">
                    Dossier à jour <span class="text-red">*</span>
                  </h5>
                  <div class="d-inline-flex mr-5">
                    <div class="custom-control custom-radio mb-3 ml-3 mr-5">
                      <input
                        type="radio"
                        id="yes"
                        value="true"
                        name="yes"
                        v-model="upToDate"
                        class="custom-control-input"
                      />
                      <label class="custom-control-label" for="yes">Oui</label>
                    </div>
                    <div class="custom-control custom-radio mb-3 ml-3">
                      <input
                        type="radio"
                        id="no"
                        value="false"
                        name="no"
                        v-model="upToDate"
                        class="custom-control-input"
                      />
                      <label class="custom-control-label" for="no">Non</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card custom-card mt-5">
          <div class="card-body">
            <div class="py-2 px-3 custom-card">
              <h5>Remarques</h5>
              <div class="row">
                <div class="col-12 jjj px-4">
                  <textarea
                    class="form-control mt-4"
                    v-model="Remarques"
                    cols="30"
                    rows="7"
                    :placeholder="
                      $t('days.off.request.step.four.explainPlaceHolder')
                    "
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import daysOffType from "../../../data/daysOff/daysOffType.js";
import contractType from "../../../data/contract/contractType";
import Errors from "../../error/errors";
import ErrorsHelper from "../../../helper/ErrorsHelper";
import TimeUtils from "../../../utils/TimeUtils";
import { fr } from "vuejs-datepicker/dist/locale";
import $ from "jquery";
import FileUpload from "../../shared/uploadFile.vue";
import validator from "validator";

export default {
  name: "StepTwo",
  components: { Errors, FileUpload },
  props: ["user", "isCEE"],
  data() {
    return {
      Remarques: "",
      daysOffType,
      contractType,
      ID: { name: `Pièce d'identité` },
      CV: { name: `Carte vitale` },
      otherDocumentsCounter: 1,
      allStructures: [],
      type: "",
      motif: "",
      email: "",
      errors: {},
      lastName: "",
      firstName: "",
      phoneNumber: "",
      adresse: "",
      socialSecurityNumber: "",
      poleEmploiInscriptionNumber: "",
      dateOfBirth: null,
      dateFrom: new Date(),
      dateTo: new Date(),
      selectedStructure: {},
      hourlyRate: "",
      periodOfTheContract: "",
      timeTable: "",
      upToDate: false,
      isThereEndDate: false,
      isMale: true,
      nationality: "",
      birthPlace: "",
      city: "",
      postalCode: "",
      fonction: "",
      daysOfContractPast11Months: 0,
      CEEType: "Séjour de vacances",
      diplomesPath: "",
      IDPath: "2",
      CVPath: "3",
      isDragging: false,
      otherContract: "",
      emailAlreadyExist: false,
      daysOfContract: 0,
      otherDocumentsPaths: [
        { name: `Diplomes`, showDelete: true, showUploadComplete: false },
        {
          name: `Permis de conduire`,
          showDelete: true,
          showUploadComplete: false,
        },
      ],
      requiredFields: ["motifOther"],
      dateRange: {
        from: null,
        fromWhichHalf: 0,
        to: null,
        toWhichHalf: 0,
      },
      disabledDatesFrom: {
        to: new Date(),
      },
      progressDiplome: 0,
      inputclass: true,
      semiDay: false,
      fr,
    };
  },
  mounted() {
    if (localStorage.getItem("model")) {
      let model = JSON.parse(localStorage.getItem("model"));
      console.log("hell: ", model);
      this.type = model.type;
      this.upToDate = model.upToDate;
      this.firstName = model.firstName;
      this.lastName = model.lastName;
      this.phoneNumber = model.phoneNumber;
      this.dateOfBirth = model.dateOfBirth;
      this.adresse = model.adresse;
      this.periodOfTheContract = model.periodOfTheContract;
      this.socialSecurityNumber = model.socialSecurityNumber;
      this.poleEmploiInscriptionNumber = model.poleEmploiInscriptionNumber;
      this.Remarques = model.Remarques;
      this.dateFrom = model.dateFrom;
      this.dateTo = model.dateTo;
      this.selectedStructure = model.selectedStructure;
      this.CV = model.CVPath;
      this.ID = model.IDPath;
      this.otherDocumentsPaths = model.otherDocumentsPaths;
      this.email = model.email;
      this.otherContract = model.otherContract;
      this.isMale = model.isMale;
      this.nationality = model.nationality;
      this.birthPlace = model.birthPlace;
      this.city = model.city;
      this.postalCode = model.postalCode;
      this.fonction = model.fonction;
      this.daysOfContractPast11Months = model.daysOfContractPast11Months;
      this.daysOfContract = model.daysOfContract;
      this.CEEType = model.CEEType;
      this.isThereEndDate = model.isThereEndDate;
    }
    this.$services.structure.findAll().then((response) => {
      this.allStructures = response.data;
    });
    if (this.isCEE) {
      this.type = "CEE";
    }
  },
  async created() {
    const datepickers = await document.getElementsByClassName("datepicker");
    for (let i = 0; i < datepickers.length; i++) {
      datepickers[i].style.cursor = "pointer";
    }
  },
  computed: {
    dateFrom() {
      return TimeUtils.formatFullDay(this.dateRange.from);
    },

    dateTo() {
      return TimeUtils.formatFullDay(this.dateRange.to);
    },
  },
  methods: {
    previous() {
      this.$emit("input", null);
    },

    checkDates() {
      if (this.dateRange.to < this.dateRange.from) {
        this.dateRange.to = null;
      }
    },

    onDragOverFiles(event) {
      this.isDragging = true;
    },

    onDragLeaveFiles(event) {
      this.isDragging = false;
    },

    async checkEmail(event) {
      await this.$services.contractRequestService
        .requestExist({ email: event.target.value })
        .then(({ data }) => {
          this.emailAlreadyExist = data;
        });
    },

    goToEmployeeExist() {
      this.$router.push(`/employee/${this.emailAlreadyExist}`);
    },

    selectHalf() {
      if (this.dateFrom == this.dateTo) {
        this.dateRange.toWhichHalf = this.dateRange.fromWhichHalf;
      }
    },

    addOtherDocument() {
      this.otherDocumentsPaths.push({
        name: `Autre document ${this.otherDocumentsCounter}`,
        showDelete: true,
        showUploadComplete: false,
      });
      this.otherDocumentsCounter++;
    },

    handleDeletingOtherDocuments(doc) {
      const index = this.otherDocumentsPaths.indexOf(doc);
      if (index > -1) {
        this.otherDocumentsPaths.splice(index, 1);
      }
    },

    nextStep() {
      if (
        !validator.isEmpty(this.firstName) &&
        !validator.isEmpty(this.lastName) &&
        !validator.isEmpty(this.phoneNumber) &&
        !validator.isEmpty(this.adresse) &&
        !validator.isEmpty(this.birthPlace) &&
        this.dateOfBirth &&
        !validator.isEmpty(this.nationality) &&
        !validator.isEmpty(this.postalCode) &&
        !validator.isEmpty(this.city) &&
        !validator.isEmpty(this.CV.path ? this.CV.path : "") &&
        !validator.isEmpty(this.ID.path ? this.ID.path : "") &&
        !validator.isEmpty(this.email) &&
        !this.emailAlreadyExist &&
        !validator.isEmpty(this.socialSecurityNumber) &&
        this.selectedStructure.id &&
        ((!validator.isEmpty(this.poleEmploiInscriptionNumber) &&
          this.type == "CDD") ||
          this.type != "CDD") &&
        ((this.isCEE == false && !validator.isEmpty(this.fonction)) ||
          this.isCEE) &&
        !validator.isEmpty(this.type)
      ) {
        let model = {
          type: this.type,
          upToDate: this.upToDate,
          firstName: this.firstName,
          lastName: this.lastName,
          phoneNumber: this.phoneNumber,
          dateOfBirth: this.dateOfBirth,
          adresse: this.adresse,
          periodOfTheContract: this.periodOfTheContract,
          socialSecurityNumber: this.socialSecurityNumber,
          poleEmploiInscriptionNumber: this.poleEmploiInscriptionNumber,
          Remarques: this.Remarques,
          dateFrom: this.dateFrom,
          dateTo: this.isThereEndDate ? this.dateTo : null,
          selectedStructure: {
            name: this.selectedStructure.name,
            id: this.selectedStructure.id,
          },
          CVPath: this.CV,
          IDPath: this.ID,
          otherDocumentsPaths: this.otherDocumentsPaths,
          email: this.email,
          otherContract: this.otherContract,
          isMale: this.isMale,
          nationality: this.nationality,
          birthPlace: this.birthPlace,
          city: this.city,
          postalCode: this.postalCode,
          fonction: this.fonction,
          daysOfContractPast11Months: this.daysOfContractPast11Months,
          daysOfContract: this.daysOfContract,
          CEEType: this.CEEType,
          isThereEndDate: this.isThereEndDate,
        };
        this.$emit("input", model);
        localStorage.setItem("model", JSON.stringify(model));
      } else {
        if (this.CV.path && this.ID.path){
          this.$miniToastr.error("veuillez renseigner tous les champs obligatoires");
        } else {this.$miniToastr.error("veuillez remplir tous les fichiers requis");}
        
      }
    },
  },
};
</script>

<style scoped>
.card {
  position: relative;
  background-color: transparent;
}

.wizard-btn-wrapper {
  position: absolute;
  top: -120px;
  right: 0;
}

.custom-card {
  background-color: #ffffff;
}

.custom-datepicker input {
  border: none !important;
  background-color: #b6bbdd !important;
  color: #007bff !important;
  border-radius: 15px !important;
  width: 50% !important;
  text-align: center !important;
  font-weight: 600 !important;
}

.document-container {
  background-color: #f6f8ff;
  border-radius: 15px;
}

.document-inside-container {
  background-color: #ffffff;
  margin: 10px 20px;
  color: #1f88ff;
  padding: 10px;
  border-radius: 10px;
  font-size: 10px;
}

.document-inside-button {
  background-color: #ffffff;
  margin: 10px 20px;
  padding: 10px;
  border-radius: 10px;
  color: #5a6169;
  font-weight: 500;
  display: flex;
  justify-content: center;
}

.document-inside-button:hover {
  cursor: pointer;
}

.document-add-button {
  border: 2px #4f78e2 dashed;
  border-radius: 15px;
  height: 100%;
  color: #4f78e2;
  padding: 10px;
}

.document-delete-button {
  position: absolute;
  top: 0;
  right: 0;
  color: #fc452d;
  background-color: #fddad5;
  border-radius: 5px;
  height: 25px;
  width: 25px;
}

.div-no-padding {
  padding: 0 !important;
}

.upload-file-text {
  margin-left: 7px;
  text-align: center;
  display: block;
}

.upload-file-icon {
  display: block;
}

.document-upload-progress-circle {
  text-align: center;
  color: #1f88ff;
}

.text-red {
  color: red;
  /* font-size: 16px; */
  font-weight: 900;
}

.emailExist {
  color: red;
  border: 1px solid red;
}

.emailExist:hover {
  border: 2px solid red;
}

.emailExistErrorText {
  color: red;
}

.emailExistErrorTextUnder {
  text-decoration: underline;
}

.emailExistErrorTextUnder:hover {
  cursor: pointer;
}
</style>
